/**
 * usePrivacyStore — persist privacy mode (Cloud vs Ẩn Danh) across sessions.
 * US-12-01 — wire real so worker can skip pending_sync when incognito.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type PrivacyMode = 'cloud_sync' | 'incognito';

interface PrivacyStore {
  mode: PrivacyMode;
  warningDismissed: boolean;
  setMode: (mode: PrivacyMode) => void;
  dismissWarning: () => void;
}

export const usePrivacyStore = create<PrivacyStore>()(
  persist(
    (set) => ({
      mode: 'cloud_sync',
      warningDismissed: false,
      setMode: (mode) => set({ mode }),
      dismissWarning: () => set({ warningDismissed: true }),
    }),
    { name: 'trans-bctn-privacy-store' }
  )
);
